module.exports = __webpack_public_path__ + "static/media/hcp-levels-table-mobile.b3577eee.svg";